import { useEffect, useState } from 'react'

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  return { width, height }
}

export const useWindowDimensions = (
  callback?: (dimensions: { height: number; width: number }) => void,
) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  )

  const handleResize = () => {
    const newDimensions = getWindowDimensions()
    setWindowDimensions(newDimensions)
    callback?.(newDimensions)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}
